import { getPeriscopeMetadataRouteUri } from '@sonar-software/sonar-ts-lib';
import { useApiResource } from '../useApiResource';
import { useMemo } from 'react';
export function usePeriscopeMetadata(sonarObjectId, sonarObjectType) {
    const targetUri = useMemo(() => getPeriscopeMetadataRouteUri(sonarObjectType, sonarObjectId), [sonarObjectId, sonarObjectType]);
    const { loading, resource } = useApiResource(targetUri);
    return {
        loading,
        metadata: resource
    };
}
